import React, {Component} from "react";
import {Link} from "react-router";
import {cx} from "../lib/ClassSet";

class MenuGroup extends Component {

  constructor(props) {
    super(props);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.state = {
      expanded: false
    }
  }

  render() {
    if (!this.props.show) return null;
    const { links, currentPath } = this.props;

    // To know in which category the current page belongs to, we:
    // - cut out the query string and id/uid from the current path
    // (water pallet ids are 18 chars, uid are 32 chars)
    // - compare that to all the links we have in this menu, minus their query strings
    const pathToCompareTo = currentPath && currentPath.split("?")[0].split(/\/[a-z0-9]{18,32}/)[0];
    const isSelected = links && links.find((l) => l.to.split("?")[0] === pathToCompareTo);
    const menuClasses = cx({
      "MenuGroup": true,
      "MenuGroup-profile": this.props.profile,
      "MenuGroup-version": this.props.version,
      "MenuGroup-production": this.props.production,
      "u-right": this.props.right,
      "u-expanded": this.state.expanded,
      "currentlySelected": isSelected,
    });

    if (links && links.length === 1) {
      // Special case with only one link: no menu is necessary
      const link = links[0];
      const linkClasses = [
        "MenuGroup",
        link.className,
        isSelected ? "currentlySelected" : null,
      ]

      return <Link to={link.to} className={linkClasses.join(" ")}>{ link.label }</Link>;
    }
    
    const content = links ? this.buildLinks(links) : this.props.children;

    return (
      <div className={menuClasses} onMouseEnter={this.handleEnter} onMouseLeave={this.handleLeave}>
        <div className="label">{this.props.label}</div>
        <div className="menu">
          { content }
        </div>
      </div>
    )
  }

  buildLinks(links) {
    return links.map((l) => <Link key={l.to} to={l.to} className={l.className}>{ l.label }</Link>);
  }

  handleEnter(e) {
    this.setState({expanded: true});
  }

  handleLeave(e) {
    this.setState({expanded: false});
  }

}

MenuGroup.defaultProps = {
  label: "Menu",
  profile: false,
  version: false,
  production: false,
  right: false,
  show: true
}

export default MenuGroup;